import React from "react";
import { connect } from "dva"
import { framework_tool, component_tool, utils_tool } from "@/tool"

import createColumns from "./columns"
import moment from "moment";
import { WizTableForm } from "../../../common";
import ApplyStudentImport from "./applyStudentImport";
import createPlanColumns from './planColumns'
import { WizPhoneCall, WizCallLog } from '@/containers/common';
import { seatsOut } from '@/utils'

let { WizContainer, modelUtils } = framework_tool
let { WizSpin, WizButton, WizInput, WizRow, WizCol, WizTabs, WizAlert, WizModal, WizForm, WizCard, WizSearchBar, WizDataTable, WizBrowserExport } = component_tool
let { TabPane } = WizTabs
let { getPageData, Session } = utils_tool;


const getParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === "/workflow/apply/applyManager") {
    if (history.location.record) {
      record = history.location.record
      Session.set('applyRecordInfo', record);
    } else {
      record = Session.get('applyRecordInfo') || {}
    }
  }
  return record
}

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

export class ApplyManager extends WizContainer {
  componentName = 'applyManager'

  constructor(props) {
    super(props);
    const { history } = props;
    this._applyRecord = getParamRecord(history)
    this.applyId = this._applyRecord.id
    this.applyDate = formatterDate(this._applyRecord.startTime) + " ~ " + formatterDate(this._applyRecord.endTime)
    this.state = {
      planType: this._applyRecord.planType,
      showStudentListVisible: false, //新增学员第一步 -- 加人
      userIdentityIds: {},
      showPlanListVisible: false, //新增学员第二部 -- 设置计划安排
      showApplyStudentImportVisible: false,
      batchReviewVisible: false,
      showAdjustPlanListVisible: false,
      rows: [],
      selectedRows: 0,
      planActivityKey: "1",
      planId: null,
      status: null,
      yuntelState: null,
      time: new Date().getTime(),
      callModalShow: false,
      locCallRecord: {},
      callLogShow: false,
    }
    this.filters = {}
  }

  _componentDidMount() {
    this._getPlanListDetail();
    seatsOut({ fun: this._seatsLoginOut })
  }

  _seatsLoginOutOver(nextProps, nextState) {
    if (nextProps.seatsLoginOut.success && nextProps.seatsLoginOut.data) {
    } else {
      wizNotice.error(nextProps.seatsLoginOut.msg);
    }
    return true;
  }
  _seatsLoginOut = (params) => {
    ClinkAgent.setup({ sipPhone: false, debug: false }, function () {
      // 注册退出响应回调方法
      ClinkAgent.registerCallback(ClinkAgent.ResponseType.LOGOUT, function (result) {
        if (result.code === 0) {
          // 退出成功
          console.log('退出成功777')
        } else {
          // 退出失败
        }
      });
    });
    ClinkAgent.logout({ logoutMode: 1, removeBinding: 0 });
    this.doAction({
      path: 'smartPhone/seatsLoginOut',
      payload: {
        key: "seatsLoginOut",
        apiParams: {
          ...params
        }
      }
    });
  }
  /**
   * 查询计划安排信息
   * @param planIds
   * @private
   */
  _getPlanList(planIds) {
    this.doAction(
      {
        path: 'applyPlan/list',
        payload: {
          key: 'planListByCond',
          apiParams: {
            ids: planIds,
            applyId: this.applyId
          }
        }
      }
    )
  }

  _getPlanListDetail(apiParams = {}) {
    let value = Object.assign([], apiParams)
    if (value['applyPlanTime'] && value['applyPlanTime'].length === 2) {
      value['startTime'] = moment(value['applyPlanTime'][0]).format("YYYY-MM-DD HH:mm")
      value['endTime'] = moment(value['applyPlanTime'][1]).format("YYYY-MM-DD HH:mm")
    }
    delete value['applyPlanTime']
    this.doAction(
      {
        path: 'applyPlan/planPageList',
        payload: {
          key: 'planListDetail',
          apiParams: {
            current: 1,
            size: 10,
            applyId: this.applyId,
            ...value
          }
        }
      }
    )
  }

  /**查询学员记录*/
  _applyRecordList(apiParams = {}) {
    if (this.filters) {
      if (this.filters.planId) {
        apiParams.planId = this.filters.planId
      }
      if (this.filters.status) {
        apiParams.status = this.filters.status
      }
    }
    this.doAction({
      path: 'apply/recordPageList',
      payload: {
        key: 'recordPageList_' + this.applyId,
        apiParams: {
          applyId: this.applyId,
          current: 1,
          size: 10,
          ...apiParams
        }
      }
    })
    if (this._applyRecord && this._applyRecord.planIds && this._applyRecord.planIds.length > 0) {
      this._getPlanList(this._applyRecord.planIds)
    }
  }

  /**跳转查看任职*/
  _onLookPosition(record) {
    this.jumpPage('push', '/workflow/apply/applyManager/lookPositionInfo', { ...record, showAuthority: false });
  }

  /**跳转查看审核信息*/
  _onLookVerify(record) {
    this.jumpPage('push', '/workflow/apply/applyManager/lookVerifyInfo', { ...record, type: 'look' });
  }
  /**
    * 拨打电话
  */
  openCall = (record) => {
    this.setState({ callModalShow: true, locCallRecord: record })
  }

  //通话记录
  openCallLog = (record) => {
    this.setState({ callLogShow: true, locCallRecord: record ? record : {} })
  }

  /**调整安排时可选择的班级*/
  _onAdjustPlan(record) {
    let { planList, planType } = this.state
    let { planId } = record
    let { planIds } = this._applyRecord
    let planIdList = planIds.split(',')
    let adjustPlanIds = planIdList.filter(i => !(i == planId))
    let beforeRecord = record
    if (planType === 0) {
      this.setState({ adjustPlanIds: adjustPlanIds, showAdjustPlanListVisible: true, beforeRecord: beforeRecord, showPlanListVisible: false })
    } else if (planType === 1) {
      let classId;
      planList && planList.length && planList.some(plan => {
        if (plan.id === planId) {
          classId = plan.entityId
          return true
        }
      })
      this.setState({ adjustPlanIds: adjustPlanIds, adjustClassId: classId, showAdjustPlanListVisible: true, beforeRecord: beforeRecord, showPlanListVisible: false })
    }
  }

  propsAndStateOnChange = {
    applyRecord: this._recordOnChange.bind(this),
    addApplyStudent: this._addApplyStudent.bind(this),
    deleteApplyRecord: this._deleteApplyStudentList.bind(this),
    batchCancelledApplyRecord: this._batchCancelledApplyRecord.bind(this),
    planList: this._getPlanListOver.bind(this),
    planListDetail: this._getPlanListDetailOver.bind(this),
    reviewApplyRecordInfo: this._getReviewApplyRecordInfo.bind(this),
    applyExport: this.applyExport.bind(this),
    seatsLoginOut: this._seatsLoginOutOver.bind(this),
  }

  _getReviewApplyRecordInfo(nextProps, nextState) {
    if (nextProps.reviewApplyRecordInfo.code === 1) {
      nextState.batchReviewVisible = false
      nextState.text = ""
      wizNotice.success(nextProps.reviewApplyRecordInfo.msg)
      this._removeSelectedRows()
      this._applyRecordList();
    } else {
      nextState.batchReviewVisible = false
      nextState.text = ""
      this._removeSelectedRows()
      let data = nextProps.reviewApplyRecordInfo['msg'];
      let str = data && data.replace(/<br\/>/g, "\n")
      wizNotice.error({
        key: 'default',
        message: '失败',
        description: (
          <div>
            <p style={{ whiteSpace: "pre-line" }}>{str}</p>
          </div>
        ),
      })
      this._applyRecordList();
    }
    return true;
  }

  _getPlanListOver(nextProps, nextState) {
    if (nextProps.planList.code === 1) {
      nextState.planList = nextProps.planList.data
    }
    return true;
  }

  _getPlanListDetailOver(nextProps, nextState) {
    if (nextProps.planListDetail.code === 1) {
      nextState.planListDetail = nextProps.planListDetail.data
    }
    return true;
  }

  _recordOnChange(nextProps, nextState) {
    if (nextProps.applyRecord.code === 1) {
      nextState.applyRecord = nextProps.applyRecord.data
    }
    return true;
  }

  _addApplyStudent(nextProps, nextState) {
    nextState.adjustVar = {}
    let msg = nextProps.addApplyStudent['msg'];
    if (nextProps.addApplyStudent.code === 1) {
      let data = nextProps.addApplyStudent['data'];
      if (data && data.length > 0) {
        let str = data && data.replace(/<br\/>/g, "\n")
        wizNotice.success({
          key: 'default',
          message: '成功',
          description: (
            <div>
              <p style={{ whiteSpace: "pre-line" }}>{str}</p>
            </div>
          ),
        })
        this._applyRecordList();
        return true
      } else {
        this._applyRecordList();
        let msgStr = msg && msg.replace(/<br\/>/g, "\n")
        wizNotice.success({
          key: 'default',
          message: '成功',
          description: (
            <div>
              <p style={{ whiteSpace: "pre-line" }}>{msgStr}</p>
            </div>
          ),
        })
      }
    } else {
      let msgStr = msg && msg.replace(/<br\/>/g, "\n")
      wizNotice.error({
        key: 'default',
        message: '操作失败',
        description: (
          <div>
            <p style={{ whiteSpace: "pre-line" }}>{msgStr}</p>
          </div>
        ),
      });
    }
  }

  _deleteApplyStudentList(nextProps, nextState) {
    if (nextProps.deleteApplyRecord.code === 1) {
      this._removeSelectedRows()
      this._applyRecordList();
    } else {
      wizNotice.error('删除学员失败：' + nextProps.deleteApplyRecord.msg);
      return false;
    }
  }

  _batchCancelledApplyRecord(nextProps, nextState) {
    if (nextProps.batchCancelledApplyRecord.code === 1) {
      this._removeSelectedRows()
      nextState.batchCancelledData = []
      this._applyRecordList({ planId: this.state.planId, status: this.state.status });
      let { adjustVar } = nextState
      if (adjustVar && adjustVar.id) {
        this._addApplyRecord(adjustVar)
      }
    } else {
      wizNotice.error('取消报名失败：' + nextProps.batchCancelledApplyRecord.msg);
      return false;
    }
  }

  _applyDisc = () => {
    let applyStatus = "";
    let applyStatusColor = { marginLeft: 20, padding: '0 5px', color: '#FFFFFF', backgroundColor: '#BEBEBE' };
    switch (this._applyRecord.status) {
      case 1:
        applyStatus = "已发布";
        applyStatusColor = { marginLeft: 20, padding: '0 5px', color: '#008B00', backgroundColor: '#B4EEB4' };
        break;
      case 2:
        applyStatus = "已取消";
        break;
      case 3:
        applyStatus = "已关闭";
        break;
      default:
        applyStatus = "草稿";
        break;
    }
    let enrollWay = "";
    switch (this._applyRecord.enrollWay) {
      case 0:
        enrollWay = "协调员报名";
        break;
      case 1:
        enrollWay = "学员报名";
        break;
    }
    let planType = "";
    switch (this._applyRecord.planType) {
      case 0:
        planType = "通用";
        break;
      case 1:
        planType = "班级";
        break;
      // case 2:
      //   planType = "活动";
      //   break;
    }
    let infoType = "";
    switch (this._applyRecord.infoType) {
      case 0:
        infoType = "无";
        break;
      case 1:
        infoType = "文字信息";
        break;
      case 2:
        infoType = "问卷收集";
        break;
    }

    const arr = [
      { label: '报名名称：', value: this._applyRecord.name },
      { label: '报名时间：', value: this.applyDate },
      { label: '报名方式：', value: enrollWay },
      { label: '安排类型：', value: planType },
      { label: '信息收集：', value: infoType }
    ]

    return arr.map((val, index) => {
      return (
        <WizRow key={val.label} type="flex" gutter={[5, 16]}>
          <WizCol span={5} md={3} xs={8} style={{ textAlign: 'right' }}>{val.label}</WizCol>
          {index ?
            <WizCol span={19} md={21} xs={16}>
              <div className='applyRecordInfo-discriptions'>{val.value}</div>
            </WizCol>
            :
            <WizCol span={19} md={21} xs={16}>
              {val.value}
              <span style={applyStatusColor}>{applyStatus}</span>
            </WizCol>
          }
        </WizRow>
      )
    })
  }

  showStudentListModal() {
    let { showStudentListVisible, applyRecord } = this.state
    let studentList = WizTableForm.Config.applyStudentRecord(this, { apiParams: { applyId: this.applyId, isNotAuth: true } })
    let tableFormProps = {
      title: '添加人员',
      showModal: true,
      showSelectValue: false,
      visible: showStudentListVisible,
      onCancel: () => this.setState({ showStudentListVisible: false }),
      selectType: 'checkbox',
      initRows: [],
      value: [],
      onSubmit: this._addStudentPlan,
      destroyOnClose: true,
      tableProps: {
        rowSelection: {
          getCheckboxProps: (record) => {
            return { disabled: record.applyState === 1 }
          }
        }
      },
    };
    return (
      <>
        {showStudentListVisible ?
          <WizTableForm
            {...studentList}
            {...tableFormProps} /> : null
        }
      </>
    )
  }

  _addStudentPlan = (values) => {
    let ids = [];
    if (values && values['valueRows']) {
      values['valueRows'].forEach(data => {
        let personIds = [];
        if (data && data['personId']) {
          if (personIds.indexOf(data['personId']) !== -1) {
            wizNotice.error("同一学员只能选择一个身份信息进行报名")
            ids = [];
          } else {
            personIds.push(data['personId'])
            if (data && data['id']) {
              ids.push(data['id'])
            }
          }
        }
      })
    }
    if (ids && ids.length > 0) {
      this.setState({
        showStudentListVisible: false,
        showPlanListVisible: true,
        showAdjustPlanListVisible: false,
        userIdentityIds: ids
      })
    }
  }

  showAdjustPlanListModal() {
    let { adjustPlanIds, adjustClassId, planType } = this.state
    let planList;
    if (planType === 0) {
      planList = WizTableForm.Config.adjustPlan(this, { apiParams: { planIds: adjustPlanIds, planType: planType } })
    }
    if (planType === 1) {
      planList = WizTableForm.Config.adjustPlan(this, { apiParams: { planIds: adjustPlanIds, classId: adjustClassId, planType: planType } })
    }
    let tableFormProps = {
      title: '选择计划安排',
      showModal: true,
      showSelectValue: false,
      destroyOnClose: true,
      visible: this.state.showAdjustPlanListVisible,
      selectType: 'radio',
      initRows: [],
      value: [],
      onSubmit: this._adjustApplyStudentList,
      onCancel: () => this.setState({ showAdjustPlanListVisible: false }),
      onOk: () => this.setState({ showAdjustPlanListVisible: false }),
    };
    return (
      <WizTableForm key={new Date().getTime() + 1} {...planList} {...tableFormProps} />
    )
  }

  showPlanListModal() {
    let { showPlanListVisible } = this.state
    let planIds = this._applyRecord.planIds
    let planList = WizTableForm.Config.plan(this, { apiParams: { applyId: this.applyId,ids: planIds.split(','), state: 1 } })
    let tableFormProps = {
      title: '选择计划安排',
      showModal: true,
      showSelectValue: false,
      destroyOnClose: true,
      visible: this.state.showPlanListVisible,
      selectType: 'radio',
      initRows: [],
      value: [],
      onSubmit: this._addApplyStudentList,
      onCancel: () => this.setState({ showPlanListVisible: false }),
      onOk: () => this.setState({ showPlanListVisible: false }),
    };
    return (
      <>
        {showPlanListVisible ?
          <WizTableForm key={new Date().getTime() + 1} {...planList} {...tableFormProps} /> : null
        }
      </>
    )
  }

  _adjustApplyStudentList = (values) => {
    let { beforeRecord } = this.state
    this._changeApplyStudentStudent(beforeRecord.id)
    let planId = ''
    if (values && values['valueRows']) {
      values['valueRows'].forEach(data => {
        planId = data['id']
      })
    }
    let vars = {};
    let userIdentityIds = []
    userIdentityIds.push(beforeRecord.userIdentityId)
    vars['userIdentityIds'] = userIdentityIds
    vars['applyId'] = this.applyId
    vars['planId'] = planId
    vars['status'] = 1
    vars['type'] = 'admin'
    vars['channel'] = 3
    vars['id'] = beforeRecord.id
    this.setState({
      adjustVar: vars,
      showStudentListVisible: false,
      showPlanListVisible: false,
      showAdjustPlanListVisible: false
    })
  }

  _addApplyStudentList = (values) => {
    let planId = ''
    if (values && values['valueRows']) {
      values['valueRows'].forEach(data => {
        planId = data['id']
      })
    }
    let { userIdentityIds } = this.state
    let vars = {};
    vars['userIdentityIds'] = userIdentityIds
    vars['applyId'] = this.applyId
    vars['planId'] = planId
    vars['status'] = 1
    vars['applicantPersonId'] = ''
    vars['type'] = 'admin'
    vars['channel'] = 0
    this._addApplyRecord(vars)
    this.setState({
      showStudentListVisible: false,
      showPlanListVisible: false,
      showAdjustPlanListVisible: false
    })
  }

  _addApplyRecord(values) {
    this.doAction({
      path: "apply/addApplyStudent",
      payload: {
        key: "addApplyStudent",
        apiParams: { ...values }
      }
    })
  }

  showApplyStudentImport() {
    let { showApplyStudentImportVisible } = this.state
    return (
      <>
        <WizModal title="批量导入"
          destroyOnClose={true}
          width={800}
          visible={showApplyStudentImportVisible}
          onOk={() => {
            this.setState({ showApplyStudentImportVisible: false })
          }}
          onCancel={() => {
            this.setState({ showApplyStudentImportVisible: false })
          }}
        >
          <ApplyStudentImport
            applyId={this.applyId}
            planIds={this._applyRecord.planIds}
            callback={(data) => {
              this._applyRecordList(this.applyId)
            }}
          />
        </WizModal>
      </>
    )
  }

  _onSelect(keys, rows) {
    let selectData = []; //删除报名
    let selectApplyData = []; //审核学员
    let batchCancelledData = []; //取消报名
    rows && rows.forEach(e => {
      if (e && e.id) {
        let id = e.id
        let status = e.status
        let selectInfos = { id, status }
        selectData.push(selectInfos)
      }
    })

    selectData && selectData.length && selectData.some(e => {
      if (e.status !== 0) {
        selectApplyData = []
        return true
      } else {
        selectApplyData.push(e)
      }
    })
    selectData && selectData.length && selectData.some(e => {
      if (e.status !== 1) {
        batchCancelledData = []
        return true
      } else {
        batchCancelledData.push(e)
      }
    })


    this.setState({
      keys,
      rows,
      selectedRows: keys.length,
      selectData,
      selectApplyData,
      batchCancelledData
    })
  }

  _removeSelectedRows() {
    this.setState({
      selectedRows: 0,
      keys: [],
      rows: [],
      selectData: [],
      selectApplyData: [],
      batchCancelledData: []
    })
  }

  _deleteApplyStudent() {
    let selectData = this.state.selectData;
    let content = '删除后数据不可恢复，您确定要删除选中的报名记录吗？'
    WizModal.confirm({
      title: '注意', content,
      onOk: () => {
        this.doAction({
          path: 'apply/deleteApplyRecord',
          payload: {
            key: 'deleteApplyRecord',
            apiParams: { deleteCmds: selectData }
          }
        })
      },
      onCancel() {
      }
    });
  }

  _auditApplyInfo = (status, record) => {
    let { text } = this.state
    let auditCmds = []
    record && record.length && record.forEach(e => {
      let auditCmd = { applyRecordId: e.id, auditInfo: text, status: status }
      auditCmds.push(auditCmd)
    })
    this.doAction({
      path: 'applyAudit/batchAudit',
      payload: {
        key: 'applyAudit@batchAudit',
        apiParams: {
          auditCmds: auditCmds
        }
      }
    })
  }

  showBatchReReview() {
    let { batchReviewVisible, selectData } = this.state
    return <>
      <WizModal title="审核学员"
        destroyOnClose={true}
        width={800}
        footer={null}
        visible={batchReviewVisible}
        onOk={() => {
          this.setState({ batchReviewVisible: false })
        }}
        onCancel={() => {
          this.setState({ batchReviewVisible: false })
        }}
      >
        <WizRow>
          <WizCol span={4}>审核意见：</WizCol>
          <WizCol span={15}>
            <WizInput.TextArea rows={4} onChange={(e) => { this.setState({ text: e.target.value }) }} />
          </WizCol>
        </WizRow>
        <WizRow>
          <WizCol style={{ marginTop: 15 }} span={4}>审核结果：</WizCol>
          <WizCol style={{ marginTop: 15 }} span={15}>
            <WizButton style={{ marginRight: 20 }} type='primary' onClick={() => { this._auditApplyInfo(2, selectData) }}>通过</WizButton>
            <WizButton type='danger' onClick={() => { this._auditApplyInfo(3, selectData) }}>未通过</WizButton>
          </WizCol>
        </WizRow>
      </WizModal>
    </>
  }

  _changeApplyStudentStudent(id) {
    let batchCancelledData = this.state.batchCancelledData;
    let ids = []
    if (id) {
      ids.push(id)
      this.doAction({
        path: 'apply/batchCancelledApplyRecord',
        payload: {
          key: 'batchCancelledApplyRecord',
          apiParams: { ids: ids }
        }
      })
    } else {
      batchCancelledData && batchCancelledData.forEach(e => {
        if (e && e.id) {
          ids.push(e.id)
        }
      })
      let content = '取消报名后数据不可恢复，您确定要取消选中的报名记录吗？'
      WizModal.confirm({
        title: '注意', content,
        onOk: () => {
          this.doAction({
            path: 'apply/batchCancelledApplyRecord',
            payload: {
              key: 'batchCancelledApplyRecord',
              apiParams: { ids: ids }
            }
          })
        },
        onCancel() {
        }
      });
    }
  }

  _applyExport() {
    this.doAction({
      path: 'apply/export',
      payload: {
        key: 'apply@export',
        apiParams: { id: this.applyId }
      }
    })
  }

  applyExport(nextProps, nextState) {
    let applyExport = nextProps.applyExport;
    if (applyExport.success) {
      let data = applyExport.data;
      let columnDefs = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'center',
            padding: '5px 0',
            color: '#595959',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
          },
        },
        {
          headerName: '账号',
          field: 'userName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '姓名',
          field: 'fullName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '手机号',
          field: 'mobile',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '组织名称',
          field: 'orgName',
          width: 35,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '岗位',
          field: 'positionName',
          width: 25,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '任职状态',
          field: 'jobStateName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '安排计划',
          field: 'planName',
          width: 30,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '报名状态',
          field: 'statusName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '报名提交时间',
          field: 'applySubmitTime',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '申请人账号',
          field: 'applicantUserName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '申请人姓名',
          field: 'applicantFullName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
        {
          headerName: '申请人邮箱',
          field: 'applicantEmail',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'center' },
          },
        },
      ]
      const jobStateEnum = ['离职', '在职'];
      const applyStatusEnum = ['待审核', '已通过', '审核中', '未通过', '已取消报名']
      data.record.forEach((val, index) => {
        val.jobStateName = jobStateEnum[val.jobState]
        val.statusName = applyStatusEnum[val.status]
      })
      WizBrowserExport({
        title: data.apply.name,
        sheetName: '报名记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data.record,
        filename: '报名记录.xlsx',
      })

    } else {
      wizNotice.error(applyExport.msg);
    }
  }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = (selectedRows) => {
    let { selectApplyData, batchCancelledData } = this.state
    let r = []
    let btns = new Map();
    btns.set('addStudents', <WizButton onClick={() => this.setState({ showStudentListVisible: true, showPlanListVisible: false, showApplyStudentImportVisible: false, batchReviewVisible: false, showAdjustPlanListVisible: false })}>添加学员</WizButton>);
    btns.set('importStudents', <WizButton onClick={() => this.setState({ showStudentListVisible: false, showPlanListVisible: false, showApplyStudentImportVisible: true, batchReviewVisible: false, showAdjustPlanListVisible: false })}>导入学员</WizButton>);
    btns.set('deleteStudents', <WizButton type="danger" onClick={() => this._deleteApplyStudent()} disabled={selectedRows < 1}>删除学员</WizButton>);
    btns.set('batchReview', <WizButton type="primary" onClick={() => this.setState({ showStudentListVisible: false, showPlanListVisible: false, showApplyStudentImportVisible: false, batchReviewVisible: true, showAdjustPlanListVisible: false })} disabled={!selectApplyData || selectApplyData.length < 1}>审核学员</WizButton>);
    btns.set('batchCancelled', <WizButton onClick={() => this._changeApplyStudentStudent()} disabled={!batchCancelledData || batchCancelledData.length < 1}>取消报名</WizButton>);
    btns.set('export', <WizButton onClick={() => this._applyExport()}>导出</WizButton>)
    btns.set('callLog', <WizButton onClick={() => this.openCallLog()}>通话记录</WizButton>)

    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    let rBtn = []
    btns.forEach((e) => {
      if (r.includes(e)) {
        rBtn.push(e)
      }
    })
    return rBtn
  }

  changeTab = (e) => {
    this.setState({
      showStudentListVisible: false, //新增学员第一步 -- 加人
      showPlanListVisible: false, //新增学员第二部 -- 设置计划安排
      showApplyStudentImportVisible: false,
      batchReviewVisible: false,
      showAdjustPlanListVisible: false,
      rows: [],
      selectedRows: 0,
      time: new Date().getTime(),
      resetType: 0
    })
    if (e === "1") {
      this.setState({ planActivityKey: "1" })
      this._getPlanListDetail()
    } else if (e === "2") {
      this.setState({ planActivityKey: "2" })
      this._applyRecordList({ planId: this.state.planId, status: this.state.status });
      if (this._applyRecord && this._applyRecord.planIds && this._applyRecord.planIds.length > 0) {
        this._getPlanList(this._applyRecord.planIds)
      }
    }
  }

  renderApplyPlanList = () => {
    let { planListDetail, applyLoading } = this.props;
    let { planId, status } = this.state
    let columns = createPlanColumns(this)
    let pageList = getPageData(planListDetail && planListDetail.data)
    let searchBarProps = {
      collapse: false,
      columns,
      record: { planId, status },
      onSearch: values => {
        this._getPlanListDetail(values)
      }
    }
    let dataTableProps = {
      loading: applyLoading,
      columns,
      rowKey: "id",
      dataItems: pageList,
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this._getPlanListDetail({ current: pageNum, size: pageSize })
      },
      onSelect: (keys, rows) => this._onSelect(keys, rows)
    }
    return (
      <WizSpin tip={'加载中'} spinning={applyLoading}>
        <div className='pagination'>
          <WizSearchBar key="applyPlan_searchBar" type="grid" {...searchBarProps} />
        </div>
        <WizDataTable key={'applyPlan_dataTable'} {...dataTableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination key={'applyPlan_pagination'} {...dataTableProps} />
        </div>
      </WizSpin>
    )
  }

  _render() {
    const { applyLoading, applyRecord } = this.props
    const { rows, selectedRows, planList, planActivityKey, callModalShow, locCallRecord, callLogShow } = this.state
    let planListInfo = []
    planList && planList.length && planList.forEach(plan => {
      planListInfo.push({ code: plan.id, codeName: plan.name })
    })
    let columns = createColumns(this, planListInfo)
    let list = getPageData(applyRecord && applyRecord.data);
    let searchBarProps = {
      columns,
      onSearch: (values,reset) => {
        this.filters = values
        this._removeSelectedRows()
        this.setState({ showAdjustPlanListVisible: false, showPlanListVisible: false })
        this._applyRecordList(this.filters)
        if(reset){
          this.filters = {}
          this._removeSelectedRows()
          this.setState({ planId: null, status: null, time: new Date().getTime(),showAdjustPlanListVisible:false,showPlanListVisible: false })
        }
      },
      onReset: () => {
        this.filters = {}
        this._removeSelectedRows()
        this.setState({ planId: undefined, status: undefined, time: new Date().getTime(), showAdjustPlanListVisible: false, showPlanListVisible: false })
      }
    }

    let dataTableProps = {
      loading: applyLoading,
      columns,
      rowKey: "id",
      dataItems: list,
      showNum: false,
      selectType: "checkbox",
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        let filters = this.filters || {};
        this._applyRecordList({ ...filters,current: pageNum, size: pageSize, planId: this.state.planId, status: this.state.status })
      },
      selectedRowKeys: rows.map(item => item.rowKey),
      onSelect: (keys, rows) => this._onSelect(keys, rows),
    }
    console.log(locCallRecord, 'locCallRecord')
    return (
      <>
        <WizCard title={"报名基本信息"}>
          {this._applyDisc()}
        </WizCard>
        <WizCard>
          <WizTabs activeKey={planActivityKey} animated={false} onChange={this.changeTab}>
            <TabPane tab="计划安排列表" key="1">
              {this.renderApplyPlanList()}
            </TabPane>
            <TabPane tab="报名记录" key="2">
              <WizSearchBar key={"applyRecord_searchBar@" + this.state.time} type="grid" {...searchBarProps} />
              <WizButton.WizGroup>
                {this._renderBtn(selectedRows)}
              </WizButton.WizGroup>
              <WizAlert
                className='alert'
                type='info'
                message={<Message selectedRows={selectedRows} removeSelectedRows={() => this._removeSelectedRows()} />}
                showIcon={true}
              />
              <WizDataTable key={'applyRecord_dataTable'} {...dataTableProps} />
              <div className='pagination'>
                <WizDataTable.Pagination key={'applyRecord_pagination'} {...dataTableProps} />
              </div>
            </TabPane>
          </WizTabs>
        </WizCard>
        {this.showStudentListModal()}
        {this.showPlanListModal()}
        {this.showApplyStudentImport()}
        {this.showBatchReReview()}
        {this.showAdjustPlanListModal()}
        {callModalShow ? <WizPhoneCall callScene={1} entityType={3} modalShow={callModalShow} record={locCallRecord}
          parentEntityId={this.applyId} closeModal={() => this.setState({ callModalShow: false })} /> : null}
        <WizModal title='通话记录' destroyOnClose={true} visible={callLogShow} footer={null} onCancel={() => this.setState({ callLogShow: false })} width={850}>
          <WizCallLog entityType={3} entityId={locCallRecord.id} parentEntityId={locCallRecord.id ? '' : this.applyId} applySurveyId={locCallRecord.entityId}
            entityTypeNew={7} />
        </WizModal>
      </>
    )
  }
}

const Message = ({ selectedRows, removeSelectedRows }) => (
  <>
    已选择 {selectedRows} 项
    <WizButton
      style={{ height: 20 }}
      type='link'
      tooltip='清空'
      onClick={() => removeSelectedRows()}
    >
      {' '}
      清空
    </WizButton>
  </>
)

const mapStateToProps = (state, ownProps) => {
  const { apply, applyPlan, applyAudit, smartPhone } = state
  const { history } = ownProps
  let applyRecordInfo = getParamRecord(history)
  const planList = modelUtils.getModelEntity(applyPlan, "planListByCond");
  const planListDetail = modelUtils.getModelEntity(applyPlan, "planListDetail");
  const applyRecord = modelUtils.getModelEntity(apply, "recordPageList_" + applyRecordInfo.id);
  const addApplyStudent = modelUtils.getModelEntity(apply, "addApplyStudent");
  const deleteApplyRecord = modelUtils.getModelEntity(apply, "deleteApplyRecord");
  const batchCancelledApplyRecord = modelUtils.getModelEntity(apply, "batchCancelledApplyRecord");
  const applyExport = modelUtils.getModelEntity(apply, "apply@export");
  const reviewApplyRecordInfo = modelUtils.getModelEntity(applyAudit, "applyAudit@batchAudit")
  const seatsLoginOut = modelUtils.getModelEntity(smartPhone, 'seatsLoginOut');
  const load = modelUtils.getLoadingState(state, 'apply');

  return {
    planList,
    applyRecord,
    addApplyStudent,
    deleteApplyRecord,
    batchCancelledApplyRecord,
    applyExport,
    planListDetail,
    reviewApplyRecordInfo,
    seatsLoginOut,
    ...load
  }
}

export default connect(mapStateToProps)(ApplyManager)
